<template>
    <div style="height: 95%; overflow-y: auto">
        <!-- <b-card class="sa-card" header="Cure residenziali - semiresidenziali" header-tag="header" footer-tag="footer" title=""> -->
        <b-row style="margin-left: 5px; margin-right: 5px">
            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <label class="sa-label-data">Cognome</label>
                <b-form-input v-model="jsonDataAccettazione.accettazioneAnagrafica.cognome" :disabled="isAccettazione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <label class="sa-label-data">Nome</label>
                <b-form-input v-model="jsonDataAccettazione.accettazioneAnagrafica.nome" :disabled="isAccettazione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <label class="sa-label-data">Codice</label>
                <b-form-input v-model="jsonDataAccettazione.numero" :disabled="isAccettazione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <label class="sa-label-data">Regime</label>
                <b-form-input v-model="jsonDataAccettazione.regime" :disabled="isAccettazione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Nato/a</label>
                <b-form-input v-model="jsonDataAccettazione.accettazioneAnagrafica.comuneNascita" required :disabled="isAccettazione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Provincia</label>
                <b-form-input v-model="jsonDataAccettazione.accettazioneAnagrafica.provinciaNascita" required :disabled="isAccettazione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Data di nascita</label>
                <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonDataAccettazione.accettazioneAnagrafica.dataNascita" type="date" :disabled="isAccettazione"></date-picker>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Residente a</label>
                <b-form-input v-model="jsonDataAccettazione.accettazioneAnagrafica.comuneResidenza" required :disabled="isAccettazione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Provincia</label>
                <b-form-input v-model="jsonDataAccettazione.accettazioneAnagrafica.provinciaResidenza" required :disabled="isAccettazione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Via</label>
                <b-form-input v-model="jsonDataAccettazione.accettazioneAnagrafica.indirizzoResidenza" :disabled="isAccettazione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Codice Fiscale</label>
                <b-form-input v-model="jsonDataAccettazione.accettazioneAnagrafica.identificativo" :disabled="isAccettazione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">Cellulare</label>
                <b-form-input v-model="jsonDataAccettazione.accettazioneAnagrafica.telefono" :disabled="isAccettazione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">E-mail</label>
                <b-form-input v-model="jsonDataAccettazione.accettazioneAnagrafica.email" :disabled="isAccettazione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Diagnosi in Ingresso</label>
                <b-form-textarea v-model="jsonDataAccettazione.diagnosiIngresso" placeholder="" rows="7" :disabled="isAccettazione"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Terapia Prescritta</label>
                <b-form-textarea v-model="jsonData.terapiaPrescritta" placeholder="" rows="7"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Frequenza</label>
                <b-form-input v-model="jsonData.frequenza"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Medico Prescrittore</label>
                <b-form-input v-model="jsonData.medicoPrescrittore"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Allergico a medicinali</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.allergicoMedicinali" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Portatore di protesi</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.portatoreProtesi" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Quali?</label>
                <b-form-textarea v-model="jsonData.allergicoMedicinaliQuali" placeholder="" rows="3"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Quali?</label>
                <b-form-textarea v-model="jsonData.portatoreProtesiQuali" placeholder="" rows="3"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Portatore di pacemaker</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.portatorePacemaker" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Affetto da epatite B o C</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.affettoEpatite" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">In stato di gravidanza</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.statoGravidanza" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Affetto da TBC</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.affettoTbc" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Affetto da HIV</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.affettoHiv" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Affetto da neoplasie oggi</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.affettoNeoplasieOggi" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">E' stato affetto da neoplasie negli ultimi 5 anni?</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.affettoNeoplasieUltimiCinqueAnni" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Quali?</label>
                <b-form-textarea v-model="jsonData.affettoNeoplasieOggiQuali" placeholder="" rows="3" :disabled="jsonData.affettoNeoplasieOggi !== 'SI'"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Quali?</label>
                <b-form-textarea v-model="jsonData.affettoNeoplasieUltimiCinqueAnniQuali" placeholder="" rows="3" :disabled="jsonData.affettoNeoplasieUltimiCinqueAnni !== 'SI'"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Altre patologie</label>
                <b-form-textarea v-model="jsonData.altrePatologie" placeholder="" rows="3"></b-form-textarea>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Intensità del dolore paziente in entrata: {{ jsonData.scalaDoloreEntrata }} </label>
                <b-form-input v-model="jsonData.scalaDoloreEntrata" type="range" min="0" max="10" step="1">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                    </template>
                </b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Intensità del dolore paziente in uscita: {{ jsonData.scalaDoloreUscita }} </label>
                <b-form-input v-model="jsonData.scalaDoloreUscita" type="range" min="0" max="10" step="1">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                    </template>
                </b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data"><strong>Esami Consegnati</strong></label>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">RX</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.esamiConsegnatiRx" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">RM</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.esamiConsegnatiRm" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">TAC</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.esamiConsegnatiTac" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">MOC</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.esamiConsegnatiMoc" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">ECOX</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.esamiConsegnatiEcox" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <label class="sa-label-data">EMG</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.esamiConsegnatiEmg" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                <label class="sa-label-data">Altro</label>
                <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.esamiConsegnatiAltro" class="mb-2 mr-sm-2 mb-sm-0" :options="sinoOptions" :value="null" value-field="value" text-field="text" required></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                <label class="sa-label-data">Dettaglio</label>
                <b-form-input v-model="jsonData.esamiConsegnatiAltroDettaglio"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Note</label>
                <b-form-textarea v-model="jsonData.note" placeholder="" rows="3"></b-form-textarea>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import "vue2-datepicker/index.css";
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    components: { DatePicker },
    data() {
        return {
            pathResource: "/rsaschedapaziente",
            id: null,
            jsonData: {
                affettoEpatite: "",
                affettoHiv: "",
                affettoNeoplasieOggi: "",
                affettoNeoplasieOggiQuali: "",
                affettoNeoplasieUltimiCinqueAnni: "",
                affettoNeoplasieUltimiCinqueAnniQuali: "",
                affettoTbc: "",
                allergicoMedicinali: "",
                allergicoMedicinaliQuali: "",
                altrePatologie: "",
                createDate: "",
                createUser: "",
                esamiConsegnatiAltro: "",
                esamiConsegnatiAltroDettaglio: "",
                esamiConsegnatiEcox: "",
                esamiConsegnatiEmg: "",
                esamiConsegnatiMoc: "",
                esamiConsegnatiRm: "",
                esamiConsegnatiRx: "",
                esamiConsegnatiTac: "",
                frequenza: "",
                id: "",
                idAccettazione: "",
                medicoPrescrittore: "",
                note: "",
                portatorePacemaker: "",
                portatoreProtesi: "",
                portatoreProtesiQuali: "",
                proprietario: "",
                scalaDoloreEntrata: "",
                scalaDoloreUscita: "",
                statoGravidanza: "",
                terapiaPrescritta: "",
                updateDate: "",
                updateUser: "",
            },
            jsonDataAccettazione: {
                accettazioneAnagrafica: {},
            },
            isAccettazione: true,
            sinoOptions: [
                { text: "- Selezionare Valore -", value: null },
                { text: "SI", value: "SI" },
                { text: "NO", value: "NO" },
            ],
        };
    },
    mounted() {
        let me = this;
        me.jsonData = {
            affettoEpatite: null,
            affettoHiv: null,
            affettoNeoplasieOggi: null,
            affettoNeoplasieOggiQuali: null,
            affettoNeoplasieUltimiCinqueAnni: null,
            affettoNeoplasieUltimiCinqueAnniQuali: null,
            affettoTbc: null,
            allergicoMedicinali: null,
            allergicoMedicinaliQuali: null,
            altrePatologie: null,
            esamiConsegnatiAltro: null,
            esamiConsegnatiAltroDettaglio: null,
            esamiConsegnatiEcox: null,
            esamiConsegnatiEmg: null,
            esamiConsegnatiMoc: null,
            esamiConsegnatiRm: null,
            esamiConsegnatiRx: null,
            esamiConsegnatiTac: null,
            frequenza: null,
            idAccettazione: null,
            medicoPrescrittore: null,
            note: null,
            portatorePacemaker: null,
            portatoreProtesi: null,
            portatoreProtesiQuali: null,
            proprietario: null,
            scalaDoloreEntrata: 0,
            scalaDoloreUscita: 0,
            statoGravidanza: null,
            terapiaPrescritta: null,
        };
    },
    watch: {
        "jsonData.affettoNeoplasieOggi": {
            handler(value) {
                let me = this;
                if (value !== "SI") {
                    me.jsonData.affettoNeoplasieOggiQuali = "";
                }
            },
            immediate: true,
        },
        "jsonData.affettoNeoplasieUltimiCinqueAnni": {
            handler(value) {
                let me = this;
                if (value !== "SI") {
                    me.jsonData.affettoNeoplasieUltimiCinqueAnniQuali = "";
                }
            },
            immediate: true,
        },
    },
    computed: {},
    methods: {
        init(jsonDataAccettazione) {
            let me = this;
            me.jsonDataAccettazione = jsonDataAccettazione;
            me.idAccettazione = jsonDataAccettazione.id;
            me.jsonData.idAccettazione = me.idAccettazione;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.openShowModalLoading();
            me.loadDataResources(me.pathResource + "/accettazione/" + me.idAccettazione, {}, me.resultResponseData, me.resultErrorData);
        },
        resultResponseData(response) {
            let me = this;

            me.closeShowModalLoading();
            me.jsonData = response.data.data;
        },
        resultErrorData(error) {
            let me = this;
            me.closeShowModalLoading();
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "";
            if (error.response.status !== 404) {
                me.$bvToast.toast(messaggio, {
                    title: "Errore",
                    autoHideDelay: 5000,
                    variant: "danger",
                });
            }
        },
        salva() {
            let me = this;
            me.saveResource(me.pathResource, me.jsonData, me.resultResponseSave, null);
        },
        resultResponseSave() {
            let me = this;
            me.loadData();
            this.$bvToast.toast("Salvataggio andato a buon fine", {
                title: "Salvataggio",
                autoHideDelay: 5000,
                variant: "success",
            });
        },
    },
};
</script>
